import React from 'react';
import cn from 'classnames';

type RatingBadgeProps = {
  id: string
  value: number
  caption: React.ReactNode
  className?: string
}

export default function RatingBadge({id, value, caption, className}: RatingBadgeProps) {
  let color = '#FD811B';
  if (value >= 9) {
    color = '#6BC50F';
  } else if (value >= 7) {
    color = '#ADCD2C';
  } else if (value >= 5) {
    color = '#F0C427';
  }
  return (
    <>
      <span id={id} style={{backgroundColor: color}}
            className={cn('inline-flex text-white font-bold items-center px-2.5 py-1 rounded-full', className)}>
        {caption}
      </span>
    </>
  );
}
